// molecules/InvoiceListItem.tsx
import { Box, List } from '@chakra-ui/react';
import FaceliftStatusBox from '@/components/Atoms/FaceliftStatusBox';
import FaceliftText from '@/components/Atoms/FaceliftText';
import type { Invoice } from '@/types/invoice';

interface InvoiceListItemProps {
  invoice: Invoice;
  isActive: boolean;
  status: {
    label: string;
    color: string;
  };
  onClick: () => void;
}

export const InvoiceListItem: React.FC<InvoiceListItemProps> = ({
  invoice,
  isActive,
  status,
  onClick,
}) => {
  return (
    <List.Item
      cursor="pointer"
      onClick={onClick}
      bg={{ base: isActive ? 'blue.50' : 'transparent', _dark: isActive ? 'blue.900' : 'transparent' }}
      _hover={{
        bg: { base: isActive ? 'blue.100' : 'gray.50', _dark: isActive ? 'blue.800' : 'gray.700' },
      }}
      p={3}
      borderRadius="md"
      borderWidth="1px"
      borderColor={{ base: isActive ? 'blue.500' : 'gray.200', _dark: isActive ? 'blue.400' : 'gray.700' }}
      transition="all 0.2s"
    >
      <Box>
        <FaceliftText
          fontWeight="600"
          fontSize="md"
          color={{ base: isActive ? 'blue.700' : 'gray.800', _dark: isActive ? 'blue.200' : 'gray.100' }}
          mb={1}
        >
          #{invoice.Invoice}
        </FaceliftText>

        <FaceliftText fontSize="sm" color={{ base: 'gray.600', _dark: 'gray.400' }} mb={1}>
          {invoice.Clinic}
        </FaceliftText>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <FaceliftText fontSize="sm" color={{ base: 'gray.600', _dark: 'gray.400' }}>
            ${invoice.QBAmtDue.toFixed(2)}
          </FaceliftText>

          <FaceliftStatusBox status={status} />
        </Box>
      </Box>
    </List.Item>
  );
};
